import type { ReactNode } from 'react';
import type { AppStatus } from '../types/api';

interface Props {
  status: AppStatus | null;
  showSpinner?: boolean;
  children?: ReactNode;
}

/**
 * Renders a status pill. Prefer passing rich content as children
 * (e.g. <strong> tags) rather than as HTML in `status.message`.
 */
export function StatusBanner({ status, showSpinner = false, children }: Props) {
  if (!status && !children) return null;
  const kind = status?.kind ?? 'info';
  return (
    <div className={`status ${kind}`} role="status">
      {showSpinner && <span className="spinner" />}
      {children ?? status?.message}
    </div>
  );
}
